export default {
  authenticated (state) {
    return state.token !== null && state.user !== null
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js